<template>
  <div>
    <v-data-table
      :items="chats"
      item-value="groupChatId" :headers="headers"
      hide-default-footer
      :no-data-text="$t('mailbox.noData')"
      :loading="loading"
      color="primary"
    >
      <template v-slot:item.date="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <template v-slot:item.chatReadCount="{ item }">
        {{ item.chatReadCount }}
      </template>

      <template v-slot:item.edit="{ item }">
        <v-btn
          @click="clickItem(item)"
          color="primary"
          variant="flat"
          size="small"
        >{{ $t('mailbox.detail') }}
        </v-btn>
      </template>

      <template v-slot:item.delete="{ item }">
        <v-btn
          @click="clickDelete(item)"
          color="error"
          variant="outlined"
          size="small"
        >{{ $t('mailbox.delete') }}
        </v-btn>
      </template>

    </v-data-table>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'MailTableContainer',

  props: {
    chats: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  // ⭕️ 修正5: emitするイベントを明示
  emits: ['click', 'delete'],

  data() {
    return {};
  },

  computed: {
    headers(): any[] {
      return [
        { title: this.$t('mailbox.dateTime') as string, key: 'date' },
        { title: this.$t('mailbox.title') as string, key: 'title' },
        { title: this.$t('mailbox.read') as string, key: 'chatReadCount' },
        { title: this.$t('mailbox.detail') as string, key: 'edit', sortable: false },
        { title: this.$t('mailbox.delete') as string, key: 'delete', sortable: false },
      ];
    },
  },

  methods: {
    formatDate(date: string): string {
      return date ? dayjs(date).format('DD/MM/YYYY') : '';
    },
    clickItem(item: any) {
      this.$emit('click', item);
    },
    clickDelete(item: any) {
      this.$emit('delete', item);
    },
  }
})
</script>